import { QueryKey, useQueryClient } from '@tanstack/react-query';

const useClearGraphCache = (key: QueryKey) => {
  const query = useQueryClient();
  const results = query.getQueryCache().find(key);

  return async () => {
    if (results) {
      query.getQueryCache().remove(results);
      await query.invalidateQueries([key]);
    }
  };
};

export default useClearGraphCache;
